import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { Editor } from 'ngx-editor'
import { EditorView } from 'prosemirror-view'
import { Plugin, PluginKey } from 'prosemirror-state'
import { insertPlaceholder } from './placeholder-plugin'
import { MatButtonModule, MatIconButton } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { TranslatePipe } from '@ngx-translate/core'
import { liftListItem, sinkListItem } from 'prosemirror-schema-list'
import { MatIconButtonSizesModule } from 'mat-icon-button-sizes'
import { undo, redo } from 'prosemirror-history'

@Component({
  selector: 'app-custom-toolbar',
  templateUrl: './custom-toolbar.component.html',
  styleUrl: './custom-toolbar.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconButton, MatButtonModule, MatIcon, MatIconButton, MatTooltipModule, TranslatePipe, MatIconButtonSizesModule],
})
export class CustomToolbarComponent implements OnInit {
  @Input()
  editor!: Editor

  @Input()
  allowPlaceholders: boolean = true

  isActive = false
  isDisabled = false
  isIndentDisabled = false
  isOutdentDisabled = false
  isUndoDisabled = false
  isRedoDisabled = false

  private updatePluginKey = new PluginKey('custom-toolbar-update')

  ngOnInit() {
    const plugin = new Plugin({
      key: this.updatePluginKey,
      view: () => ({
        update: this.update.bind(this),
      }),
    })

    this.editor.registerPlugin(plugin)
  }

  handleClick(event: MouseEvent) {
    event.preventDefault()
    const { state, dispatch } = this.editor.view
    insertPlaceholder(state, dispatch)
    this.editor.view.focus()
  }

  handleIndent(event: MouseEvent) {
    event.preventDefault()
    const { state, dispatch } = this.editor.view
    const { schema } = state

    const listItemType = schema.nodes['list_item']
    sinkListItem(listItemType)(state, dispatch)
    this.editor.view.focus()
  }

  handleOutdent(event: MouseEvent) {
    event.preventDefault()
    const { state, dispatch } = this.editor.view
    const { schema } = state

    const listItemType = schema.nodes['list_item']
    liftListItem(listItemType)(state, dispatch)
    this.editor.view.focus()
  }

  handleUndo(event: MouseEvent) {
    event.preventDefault()
    const { state, dispatch } = this.editor.view
    undo(state, dispatch)
    this.editor.view.focus()
  }

  handleRedo(event: MouseEvent) {
    event.preventDefault()
    const { state, dispatch } = this.editor.view
    redo(state, dispatch)
    this.editor.view.focus()
  }

  update(view: EditorView) {
    const { state } = view
    const { schema } = state
    this.isDisabled = !state.selection.empty && state.selection.$from.parent.type.spec['code'] === true
    const listItemType = schema.nodes['list_item']
    this.isIndentDisabled = !sinkListItem(listItemType)(state)
    this.isOutdentDisabled = !liftListItem(listItemType)(state)
    this.isUndoDisabled = !undo(state)
    this.isRedoDisabled = !redo(state)
  }
}
